import { Controller } from '@hotwired/stimulus'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import AWSCredentialsForm from '~/dashboard/aws_credentials_form/aws_credentials_form'

export default class AWSCredentialsFormController extends Controller {
  static values = {
    errors: Object,
  }

  initialize() {
    const component = this.createComponent()
    const container = this.element.querySelector('.aws-credentials-form-fields')

    this.root = createRoot(container)
    this.root.render(
      <StrictMode>
        <I18nProvider i18n={i18n}>{component}</I18nProvider>
      </StrictMode>,
    )
  }

  createComponent() {
    const submit = (payload) => {
      this.hiddenNameField.value = payload.name
      this.hiddenPlatform.value = payload.platform
      this.hiddenAuthType.value = payload.auth_type
      this.hiddenAuthMethod.value = payload.auth_method
      this.hiddenAuthFields.value = payload.auth_fields
      this.hiddenIsDefault.value = payload.is_default

      this.element.requestSubmit()
    }

    return <AWSCredentialsForm onSubmit={submit} errors={this.errorsValue} />
  }

  connect() {
    this.hiddenNameField = this.element.querySelector('[name="aws_credential[name]"]')
    this.hiddenPlatform = this.element.querySelector('[name="aws_credential[platform]"]')
    this.hiddenAuthType = this.element.querySelector('[name="aws_credential[auth_type]"]')
    this.hiddenAuthMethod = this.element.querySelector('[name="aws_credential[auth_method]"]')
    this.hiddenAuthFields = this.element.querySelector('[name="aws_credential[fields_by_auth_type]"]')
    this.hiddenIsDefault = this.element.querySelector('[name="aws_credential[is_default]"]')
  }

  disconnect() {
    this.root.unmount()
  }
}
